import * as React from 'react'

import { styled } from '../../../common/ui'
import { ArrowDownIcon, ArrowUpIcon } from '../icons'
import { theme } from '../theme'

interface State {
  longBodyVisible: boolean
}
export class Description extends React.Component<
  { shortBody: string; body?: string | null },
  State
> {
  state: State = {
    longBodyVisible: false,
  }
  render() {
    const { longBodyVisible } = this.state
    const { shortBody, body } = this.props
    const showAll = !!body
    let currentText = showAll
      ? longBodyVisible
        ? shortBody + '\n' + body
        : shortBody
      : shortBody
    currentText = currentText.replace(/<[^>]*>?/g, '').replace('\n', '<br />')

    return (
      <Container>
        <Text>
          <div dangerouslySetInnerHTML={{ __html: currentText }} />
          {showAll && (
            <Trigger
              onClick={e => {
                e.preventDefault()
                this.setState(state => {
                  return { longBodyVisible: !state.longBodyVisible }
                })
              }}
            >
              {longBodyVisible ? (
                <>
                  <ArrowUpIcon w={15} h={15} fill="#fff" />
                  zwiń
                </>
              ) : (
                <>
                  <ArrowDownIcon w={15} h={15} fill="#fff" />
                  czytaj więcej
                </>
              )}
            </Trigger>
          )}
        </Text>
      </Container>
    )
  }
}

const Trigger = styled.button`
  color: #fff;
  font-weight: bold;
  border: 0;
  color: #fff;
  background: transparent;
  padding: 5px 10px;
  margin: 5px 0;
  svg {
    margin-right: 15px;
  }
  &:hover {
    background: ${theme.colors.blueDark};
    cursor: pointer;
  }
  &:active,
  &:focus {
    outline: ${theme.outline};
  }
`

const Container = styled.div`
  margin: 0 0 25px 0;
`

const Text = styled.div`
  color: #fff;
  font-size: 16px;
  line-height: 23px;
`
